import { render } from "./PreviewOptin.vue?vue&type=template&id=ca53cb9c"
import script from "./PreviewOptin.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewOptin.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/PreviewOptin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca53cb9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca53cb9c', __exports__)) {
    api.reload('ca53cb9c', __exports__)
  }
  
  module.hot.accept("./PreviewOptin.vue?vue&type=template&id=ca53cb9c", () => {
    api.rerender('ca53cb9c', render)
  })

}


export default __exports__